export default {
  'password': 'パスワードを入力してください',
  'passwordError': 'パスワードは8〜20桁で、大文字と小文字、数字、記号の3つ以上の組み合わせのみが可能です',
  'passwordAgain': 'パスワードを再入力してください',
  'passwordNotSame': 'パスワードが一致していません。もう一度入力してください',
  'requiredVerifyCode': '認証コードを入力してください',
  'verifyCode': '認証コードエラー'
}
